import api from '@/lib/api';

export type EventCategoryItem = {
  id: string;
  name: string;
  slug: string;
  short_description?: string | null;
  full_description?: string | null;
  icon_name?: string | null;
  icon_type?: 'lucide' | 'heroicons' | 'tabler' | null;
  color_theme?: string | null;
  background_color?: string | null;
  text_color?: string | null;
  sort_order: number;
  is_featured: boolean;
  cover_image?: string | null;
  banner_image?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
};

export type CategoryTemplateItem = {
  id: string;
  category_id: string;
  title: string;
  slug: string;
  short_description?: string | null;
  thumbnail?: string | null;
  template_json?: Record<string, unknown> | null;
  usage_count: number;
  is_featured: boolean;
};

type Meta = { current_page: number; last_page: number; per_page: number; total: number };

export const eventDiscoveryApi = {
  categories: (params?: { featured?: boolean }) =>
    api.get<{ success: boolean; data: EventCategoryItem[]; meta: { total: number } }>('/v1/event-categories', { params, cacheTtlMs: 300000 } as any),
  categoryBySlug: (slug: string) =>
    api.get<{ success: boolean; data: EventCategoryItem & { stats?: { total_events: number; total_attendees: number; live_events: number } } }>(`/v1/event-categories/${slug}`),
  categoryTemplates: (slug: string, params?: { page?: number; per_page?: number }) =>
    api.get<{ success: boolean; data: CategoryTemplateItem[]; meta: Meta }>(`/v1/event-categories/${slug}/templates`, { params }),
  categoryEvents: (slug: string, params?: { page?: number; per_page?: number }) =>
    api.get<{ success: boolean; data: any[]; meta: Meta }>(`/v1/event-categories/${slug}/events`, { params }),
  myEventSections: (params?: { tab?: 'saved_drafts' | 'live_events' | 'past_events'; page?: number; per_page?: number }) =>
    api.get<{ success: boolean; data: any[]; meta: Meta & { tab: string } }>('/v1/users/me/event-sections', { params }),
};

